// src/core/config/arrivalPresentation.js
//
// Single source of truth for arrivals/headway presentation values (colours,
// legend labels, and typography weights). Core components read from here so a
// client can restyle the arrivals board by overriding this one module via a
// Vite alias (see clients/*/frontend/vite.config.js) — no component duplication.
//
// Defaults below reproduce the original core appearance exactly.

export const arrivalPresentation = {
  // Timezone used when normalising/formatting arrival times.
  timezone: 'Europe/London',

  // Arrival status colours, keyed by getArrivalStatus().status.
  status: {
    unknown:   { color: 'var(--text-muted)', bgColor: 'transparent' },
    late:      { color: 'var(--live-red)',   bgColor: 'var(--live-red-bg)' },
    early:     { color: 'var(--live-green)', bgColor: 'var(--live-green-bg)' },
    'on-time': { color: 'var(--accent)',     bgColor: 'var(--accent-dim)' },
  },

  // Headway colours, keyed by headway classification.
  headway: {
    tight:    { color: 'var(--live-red)',        bg: 'var(--live-red-bg)' },
    normal:   { color: 'var(--accent)',          bg: 'var(--accent-dim)' },
    large:    { color: 'var(--live-green)',      bg: 'var(--live-green-bg)' },
    fallback: { color: 'var(--text-secondary)',  bg: 'transparent' },
  },

  // Legend rows (label + swatch colour + text) shown on the board / panel.
  legend: {
    arrival: [
      { color: 'var(--live-green)', text: 'Early' },
      { color: 'var(--accent)',     text: 'On Time' },
      { color: 'var(--live-red)',   text: 'Late' },
    ],
    headway: [
      { color: 'var(--live-green)', text: 'Large' },
      { color: 'var(--accent)',     text: 'Normal' },
      { color: 'var(--live-red)',   text: 'Tight' },
    ],
  },

  // Typography weights for the time cell values.
  timeCell: {
    liveFontWeight: 600,
    headwayFontWeight: 400,
  },
};

export default arrivalPresentation;